"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var backgroundColor = _a.backgroundColor, checked = _a.checked, checkable = _a.checkable;
            // eslint-disable-next-line no-nested-ternary
            var background = checked
                ? '#f0f5f9'
                : backgroundColor
                    ? theme.palette.background.default
                    : 'inherit';
            return {
                display: 'flex',
                gap: '10px',
                boxShadow: !checked ? '-2px 2px 4px 0 rgba(0, 0, 0, 0.15)' : 'none',
                alignItems: 'center',
                padding: '8px 68px 8px 12px',
                height: '50px',
                width: '100%',
                border: "solid  ".concat(checked ? "2px ".concat(themes_1.materialColors.blue[600]) : "1px ".concat(themes_1.materialColors.blue[100])),
                position: 'relative',
                // eslint-disable-next-line no-nested-ternary
                backgroundColor: checkable
                    ? background
                    : backgroundColor
                        ? theme.palette.background.default
                        : 'inherit',
                '& label': {
                    marginRight: '0px',
                },
                marginBottom: 'none',
            };
        },
        icon: {
            position: 'absolute',
            cursor: 'pointer',
            right: '24px',
            top: '16px',
            zIndex: 3,
        },
        dragIcon: {
            height: '28px',
            width: '28px',
            flexShrink: 0,
            cursor: 'move',
        },
        selectedText: {
            marginTop: 3,
            color: themes_1.materialColors.blue[600],
        },
    });
});
